import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { Grid, Container, Typography } from '@mui/material'
import Header from '../../headerone/Main'
import Bredcom from '../../Bredcom/Main'
import { TableDataPresentation, ListDataPresentation } from '../../../utils/utils'
import MainTitle from '../../muiHome/mainTitle'
import NewMain from '../../headerone/newMain'
function FeeStructure() {
	const SOETfeeStructureData = [
		{'Courses': 'B.Tech CSE', 'eligibility ': '10+2 with 50% marks in PCM', 'Duration': '4', 'Tuition Fee': '107000',  'Other Charges': '20000',   '1st Year Onwards': '127000',},
		{'Courses': 'B.Tech CSE (AI & ML)', 'eligibility ': '10+2 with 50% marks in PCM', 'Duration': '4', 'Tuition Fee': '128000', 'Other Charges': '20000', '1st Year Onwards': '148000'},
		{'Courses': 'B.Tech CSE (Cyber Security)', 'eligibility ': '10+2 with 50% marks in PCM', 'Duration': '4', 'Tuition Fee': '107000', 'Other Charges': '20000', '1st Year Onwards': '127000'},
		{'Courses': 'B.Tech Civil Engineering', 'eligibility ': '10+2 with 50% marks in PCM', 'Duration': '4', 'Tuition Fee': '70000', 'Other Charges': '20000', '1st Year Onwards': '90000'},
		{'Courses': 'B.Tech ME (Robotics & Automation)', 'eligibility ': '10+2 with 50% marks in PCM', 'Duration': '4', 'Tuition Fee': '70000', 'Other Charges': '20000', '1st Year Onwards': '90000'},
		{'Courses': 'B.Tech ME(Electric Vechile Technology)*', 'eligibility ': '10+2 with 50% marks in PCM', 'Duration': '4', 'Tuition Fee': '70000', 'Other Charges': '20000', '1st Year Onwards': '90000'},
		{'Courses': 'M.Tech CSE', 'eligibility ': 'B.Tech CSE with 50% marks', 'Duration': '2', 'Tuition Fee': '60000', 'Other Charges': '20000', '1st Year Onwards': '80000'},
		{'Courses': 'B.Sc Computer Science', 'eligibility ': '10+2 with 50% marks in PCM', 'Duration': '3', 'Tuition Fee': '52000', 'Other Charges': '20000', '1st Year Onwards': '72000'},
		{'Courses': 'BCA', 'eligibility ': '10+2 with 50% marks in Any Stream', 'Duration': '3', 'Tuition Fee': '57000', 'Other Charges': '20000', '1st Year Onwards': '77000'},
		{'Courses': 'BCA (Data Science)', 'eligibility ': '10+2 with 50% marks in Any Stream', 'Duration': '3', 'Tuition Fee': '65000', 'Other Charges': '20000', '1st Year Onwards': '85000'},
		{'Courses': 'BCA (AI & DA)', 'eligibility ': '10+2 with 50% marks in Any Stream', 'Duration': '3', 'Tuition Fee': '65000', 'Other Charges': '20000', '1st Year Onwards': '85000'},
		{'Courses': 'MCA', 'eligibility ': 'Graduate in Related Stream with 50% marks', 'Duration': '2', 'Tuition Fee': '45000', 'Other Charges': '20000', '1st Year Onwards': '65000'}
	  ];
	  
	  const SBMCfeeStructureData = [
		{'Courses': 'B.Com (H)', 'eligibility ': '10+2 with 50% marks in Commerce', 'Duration': '3', 'Tuition Fee': '35000', 'Other Charges': '20000', '1st Year Onwards': '55000'},
		{'Courses': 'BBA', 'eligibility ': '10+2 with 45% marks in Any Stream', 'Duration': '3', 'Tuition Fee': '50000', 'Other Charges': '20000', '1st Year Onwards': '70000'},
		{'Courses': ' BBA (Digital Marketing)', 'eligibility ': '10+2 with 45% marks in Any Stream', 'Duration': '3', 'Tuition Fee': '60000', 'Other Charges': '20000', '1st Year Onwards': '80000'},
		{'Courses': ' BBA (Business Analytics)', 'eligibility ': '10+2 with 45% marks in Any Stream', 'Duration': '3', 'Tuition Fee': '60000', 'Other Charges': '20000', '1st Year Onwards': '80000'},
		{'Courses': 'MBA(HR, Marketing, Finance, Business Analytics)', 'eligibility ': 'Any Graduate with 50% marks', 'Duration': '2', 'Tuition Fee': '75000', 'Other Charges': '20000', '1st Year Onwards': '95000'},
		//{'Courses': 'MBA (HR, Marketing, Finance, Business Analytics)', 'eligibility ': 'Any Graduate with 50%', 'Duration': '2', 'Tuition Fee': '75000', 'Other Charges': '17000', '1st Year Onwards': '92000'},
		//{'Courses': '   MBA (Real Estate Management)', 'eligibility ': 'Any Graduate with 50%', 'Duration': '2', 'Tuition Fee': '75000', 'Other Charges': '17000', '1st Year Onwards': '92000'},
		//{'Courses': 'MBA (Pharm Management)', 'eligibility ': 'Any Graduate with 50%', 'Duration': '2', 'Tuition Fee': '75000', 'Other Charges': '17000', '1st Year Onwards': '92000'},
		//{'Courses': 'MBA (Hospital Management)', 'eligibility ': 'Any Graduate with 50%', 'Duration': '2', 'Tuition Fee': '75000', 'Other Charges': '17000', '1st Year Onwards': '92000'}
	  ];

	  
	  const SOPSfeeStructureData=[
        {'Courses':'D. Pharmacy','eligibility ':'10+2 with 50% marks in PCB/M','Duration':'2','Tuition Fee':'70000' ,'Other Charges':'20000','1st Year Onwards':'90000'},
        {'Courses':'B. Pharmacy','eligibility ':'10+2 with 50% marks in PCB/M (Age 17 Years)','Duration':'4','Tuition Fee':'130000' ,'Other Charges':'20000','1st Year Onwards':'150000'},
        {'Courses':'Pharm D','eligibility ':'10+2 with 50% marks in PCB/M','Duration':'6','Tuition Fee':'175000' ,'Other Charges':'20000','1st Year Onwards':'195000'},
        {'Courses':'   M. Pharmacy (Pharmaceutics,Pharmacology, DRA)','eligibility ':'B. Pharmacy with 55% marks','Duration':'2','Tuition Fee':'80000' ,'Other Charges':'20000','1st Year Onwards':'100000'},
       /* {'Courses':'M. Pharmacy (Pharmacology)','eligibility ':'B. Pharmacy with 55% marks','Duration':'2','Tuition Fee':'107000' ,'Other Charges':'124000','1st Year Onwards':'124000'},
        {'Courses':'M. Pharmacy (Drug Regulatory Affairs)','eligibility ':'B. Pharmacy with 55% marks','Duration':'2','Tuition Fee':'107000' ,'Other Charges':'124000','1st Year Onwards':'124000'}, */
    ]



	const SOLfeeStructureData = [
		{ 'Courses': 'BA LLB', 'eligibility ': '10+2 with 45% marks in Any Stream', 'Duration': '5', 'Tuition Fee': '65000', 'Other Charges': '20000', '1st Year Onwards': '85000' },
		{ 'Courses': 'BBA LLB', 'eligibility ': '10+2 with 45% marks in Any Stream', 'Duration': '5', 'Tuition Fee': '62000', 'Other Charges': '20000', '1st Year Onwards': '82000' },
		{ 'Courses': 'LLB', 'eligibility ': 'Any Graduate with 45% marks', 'Duration': '3', 'Tuition Fee': '40000', 'Other Charges': '20000', '1st Year Onwards': '60000' },
		{ 'Courses': 'LLM', 'eligibility ': '3 to 5 Years LLB with 50% marks', 'Duration': '2', 'Tuition Fee': '40000', 'Other Charges': '20000', '1st Year Onwards': '60000' }
	  ];
	  


const SAHSfeeStructureData = [
	{'Courses': 'Diploma in Health Assistant-DHA (After 10th Class)', 'eligibility ': '10th/10+2 with 50% marks', 'Duration': '3', 'Tuition Fee': '52000', 'Other Charges': '20000', '1st Year Onwards': '72000'},
	{'Courses': 'Diploma in Medical Lab Technology (DMLT)', 'eligibility ': '10+2 with 50% marks in PCB', 'Duration': '2', 'Tuition Fee': '40000', 'Other Charges': '20000', '1st Year Onwards': '60000'},
	{'Courses': 'B.Sc in Medical Lab Technology (BMLT)', 'eligibility ': '10+2 with 50% marks in PCB', 'Duration': '4', 'Tuition Fee': '62000', 'Other Charges': '20000', '1st Year Onwards': '82000'},
	{'Courses': 'B.Sc (Biotechnology)', 'eligibility ': '10+2 with 50% marks in PCB/M', 'Duration': '3', 'Tuition Fee': '47000', 'Other Charges': '20000', '1st Year Onwards': '67000'},
	{'Courses': '   B.Sc. in Cardiovascular Technology (CVT)', 'eligibility ': '10+2 with 50% marks in PCB', 'Duration': '4', 'Tuition Fee': '72000', 'Other Charges': '20000', '1st Year Onwards': '92000'},
	{'Courses': 'Bachelor of Physiotherapy (BPT)', 'eligibility ': '10+2 with 50% marks in PCB and NEET(Age- 17 Years)', 'Duration': '5', 'Tuition Fee': '110000', 'Other Charges': '20000', '1st Year Onwards': '130000'},
	{'Courses': 'M.Sc Medical Lab Technology (M.Sc MLT)', 'eligibility ': 'Graduate in Related Stream with 50% marks', 'Duration': '2', 'Tuition Fee': '60000', 'Other Charges': '20000', '1st Year Onwards': '80000'},
	{'Courses': 'M.Sc (Microbiology)', 'eligibility ': 'Graduate in Related Stream with 50% marks', 'Duration': '2', 'Tuition Fee': '60000', 'Other Charges': '20000', '1st Year Onwards': '80000'},
	{'Courses': 'M.Sc. (Biotechnology)', 'eligibility ': 'Graduate in Related Stream with 50% marks', 'Duration': '2', 'Tuition Fee': '60000', 'Other Charges': '20000', '1st Year Onwards': '80000'},
	{'Courses': 'Note: BPT, BMLT & B.Sc CVT(Last 1 year Training)', 'eligibility ': '', 'Duration': '', 'Tuition Fee': '', 'Other Charges': '', '1st Year Onwards': ''},
];

  
  const SSHfeeStructureData = [
	{'Courses': 'B.Sc (Medical)', 'eligibility ': '10+2 with 50% marks in PCB', 'Duration': '3', 'Tuition Fee': '30000', 'Other Charges': '5000', '1st Year Onwards': '35000'},
	{'Courses': 'B.Sc (Non Medical)', 'eligibility ': '10+2 with 50% marks in PCM', 'Duration': '3', 'Tuition Fee': '30000', 'Other Charges': '5000', '1st Year Onwards': '35000'},
	{'Courses': 'BA (Pass)', 'eligibility ': '10+2 with 50% marks in Any Stream', 'Duration': '3', 'Tuition Fee': '30000', 'Other Charges': '5000', '1st Year Onwards': '35000'},
	{'Courses': 'BA (Economics-Honours)', 'eligibility ': '10+2 with 50% marks in Any Stream', 'Duration': '3', 'Tuition Fee': '30000', 'Other Charges': '5000', '1st Year Onwards': '35000'},
	{'Courses': 'BA (Political Science)', 'eligibility ': '10+2 with 50% marks in Any Stream', 'Duration': '3', 'Tuition Fee': '30000', 'Other Charges': '5000', '1st Year Onwards': '35000'},
	{'Courses': 'BA (Journalism & Mass Communication)', 'eligibility ': '10+2 with 50% marks in Any Stream', 'Duration': '3', 'Tuition Fee': '50000', 'Other Charges': '5000', '1st Year Onwards': '55000'},
  ];

  

	const LEAfeeStructureData=[
		/*
        {'Courses':'B.Tech CSE (Leet)','eligibility ':'Diploma/B.Sc (Maths) with 50% marks','Duration':'3','Tuition Fee':'105000' ,'Other Charges':'130200','1st Year Onwards':'114200'},
        {'Courses':'B.Pharmacy (Leet)','eligibility ':'D.Pharm with 50% marks','Duration':'3','Tuition Fee':'125000' ,'Other Charges':'150200','1st Year Onwards':'134200'},
        {'Courses':'B.Sc inMedical Lab Technology (BMLT) (Leet)','eligibility ':'DMLT with 50% marks','Duration':'2','Tuition Fee':'60000' ,'Other Charges':'85200','1st Year Onwards':'69200'},
	*/]

	const DoctoralfeeStructureData = [
		{'Courses': 'Ph.D (All)', 'eligibility ': 'PG with 55% marks', 'Duration': '3', 'Tuition Fee': '85000', 'Other Charges': '20000', '1st Year Onwards': '105000'},
	  ];
	  
	  const hostalFeeData = [
		{ item: 'Triple Seater (Non AC) with Meal', fee: '₹ 96000/-' },
		{ item: 'Triple Seater (AC) with Meal', fee: '₹ 130000/-' }
	  ];

	  const noteList = [
		{ listName: '1. Uniform fee Rs. 4500/- will be charged extra.' },
		{ listName: '2. HSTES Counselling fee (B.Pharm) will be charged extra.' },
		{ listName: '3. For Pharmacy courses eligibility documents verification is mandatory as per PCI norms and charges for the same will be charged extra.' },
		{ listName: '4. UGC norms will be adhered for fee refund.' },
		{ listName: '5. Hostel/Transport Fee will be provided for full Academic year only.' },
		{ listName: '6. All the dispute are subjected to Palwal judiciary.' },
		{ listName: '7. Convocation Fee will be charged extra, wherever applicable.' },
		{ listName: '8. Dissertation Charges will be charged extra for the relevant programmes, wherever applicable.' }
		//{ listName: '1. HSTES Counselling fee (B.Pharm) will be charged extra.' },
		//{ listName: '2. For Pharmacy courses eligibility documents verification is mandatory as per PCI norms and charges for the same will be charged extra.' },
		//{ listName: '3. UGC norms will be adhered to for fee refunds.' },
		//{ listName: '4. Hostel/Transport Fee will be applicable for the full academic year only.' },
		//{ listName: '5. All disputes are subject to Palwal judiciary.' }
	  ];

	  
	return (
		<>
			<NewMain />
			<Bredcom title="Home" subtitle="Course Fee Structure With Eligibility (Academic Year 2026-27)					" />
			<Container>
			<Grid container spacing={2} marginTop={10}>
				<Grid item xs={12}>
					<MainTitle title='Course Fee Structure With Eligibility (Academic Year 2026-27)					'/>
				</Grid>
				{/*<Grid item xs={12}>
					<MainTitle title='School of engineering & Technology'/>
				</Grid>  */}
				<Grid item xs={12}>
				<TableDataPresentation data={SOETfeeStructureData}/>
				</Grid>
				<Grid item xs={12}>
					<MainTitle title='School of business management and commerce'/>
				</Grid>
				<Grid item xs={12}>
				<TableDataPresentation data={SBMCfeeStructureData}/>
				</Grid>
				<Grid item xs={12}>
					<MainTitle title='School of Pharmaceutical science'/>
				</Grid>
				<Grid item xs={12}>
				<TableDataPresentation data={SOPSfeeStructureData}/>
				</Grid>
				<Grid item xs={12}>
					<MainTitle title='School of Law'/>
				</Grid>
				<Grid item xs={12}>
				<TableDataPresentation data={SOLfeeStructureData}/>
				</Grid>
				<Grid item xs={12}>
					<MainTitle title='School of Allied health sciences'/>
				</Grid>
				<Grid item xs={12}>
				<TableDataPresentation data={SAHSfeeStructureData}/>
				</Grid>
				<Grid item xs={12}>
					<MainTitle title='School of Science and humanities'/>
				</Grid>
				<Grid item xs={12}>
				<TableDataPresentation data={SSHfeeStructureData}/>
				</Grid>
				{/*<Grid item xs={12}>
					<MainTitle title='Lateral Entery Admissions Fee Structure'/>
				</Grid>
				<Grid item xs={12}>
				<TableDataPresentation data={LEAfeeStructureData}/>
				</Grid>  */}
				<Grid item xs={12}>
					<MainTitle title='Doctoral Programmes'/>
				</Grid>
				<Grid item xs={12}>
				<TableDataPresentation data={DoctoralfeeStructureData}/>
				</Grid>
				<Grid item xs={12}>
					<MainTitle title='Hostel Fees'/>
				</Grid>
				<Grid item xs={12}>
				<TableDataPresentation data={hostalFeeData}/>
				</Grid>
				 
	<Grid item xs={12}>
    <MainTitle title="Notes" />
    </Grid>

    <Grid item xs={12}>
    <ListDataPresentation DataList={noteList}/>
    </Grid>
			</Grid>
			</Container>
			

		</>
	)
}

export default FeeStructure